(() => {
  'use strict';

  /* =========================================================
     VSX9 ALL COLLECTION
     Wishlist + Cart + Buy Now + Sort + Compare
  ========================================================= */

  const VSX9_WISHLIST_KEY = 'vsx9_wishlist_v1';
  const VSX9_COMPARE_KEY = 'vsx9_compare_v1';

  const VSX9_COMPARE_EVENT = 'vs:compare:updated';
  const VSX9_MAX_COMPARE = 4;


  /* =========================================================
     HELPERS
  ========================================================= */

  function getRoot() {
    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {
      return window.Shopify.routes.root;
    }

    return '/';
  }


  function safeParse(value, fallback = []) {
    try {
      const parsed = JSON.parse(value || '[]');
      return Array.isArray(parsed) ? parsed : fallback;
    } catch (error) {
      return fallback;
    }
  }


  /* =========================================================
     WISHLIST
     EXISTING SYSTEM PRESERVED
  ========================================================= */

  function getWishlist() {
    try {
      const saved =
        localStorage.getItem(VSX9_WISHLIST_KEY);

      return safeParse(saved, []);

    } catch (error) {
      return [];
    }
  }


  function saveWishlist(items) {
    try {
      localStorage.setItem(
        VSX9_WISHLIST_KEY,
        JSON.stringify(items)
      );
    } catch (error) {}

    document.dispatchEvent(
      new CustomEvent(
        'vs:wishlist:updated',
        {
          detail: { items }
        }
      )
    );
  }


  function syncWishlist() {

    const items = getWishlist();

    document
      .querySelectorAll('[data-vs-wishlist-toggle]')
      .forEach(button => {

        const id =
          String(button.dataset.productId || '');

        const active =
          items.some(
            item =>
              String(item.id) === id
          );

        button.classList.toggle(
          'is-active',
          active
        );

        button.setAttribute(
          'aria-pressed',
          active ? 'true' : 'false'
        );

        button.setAttribute(
          'aria-label',
          active
            ? 'Remove from wishlist'
            : 'Add to wishlist'
        );

      });

  }


  function toggleWishlist(button) {

    const id =
      String(button.dataset.productId || '');

    if (!id) {
      return;
    }

    let items =
      getWishlist();

    const index =
      items.findIndex(
        item =>
          String(item.id) === id
      );

    if (index >= 0) {

      items.splice(index, 1);

    } else {

      items.push({

        id,

        handle:
          button.dataset.productHandle || '',

        title:
          button.dataset.productTitle || '',

        url:
          button.dataset.productUrl || '',

        image:
          button.dataset.productImage || '',

        price:
          button.dataset.productPrice || '',

        variantId:
          button.dataset.variantId || ''

      });

    }

    saveWishlist(items);
    syncWishlist();

  }


  /* =========================================================
     COMPARE
  ========================================================= */

  function getCompare() {

    try {

      const saved =
        localStorage.getItem(
          VSX9_COMPARE_KEY
        );

      return safeParse(
        saved,
        []
      );

    } catch (error) {

      return [];

    }

  }


  function saveCompare(items) {

    try {

      localStorage.setItem(
        VSX9_COMPARE_KEY,
        JSON.stringify(items)
      );

    } catch (error) {}

    document.dispatchEvent(
      new CustomEvent(
        VSX9_COMPARE_EVENT,
        {
          detail: {
            items
          }
        }
      )
    );

  }


  function buildCompareItem(button) {

    return {

      id:
        String(
          button.dataset.productId || ''
        ),

      handle:
        button.dataset.productHandle || '',

      title:
        button.dataset.productTitle || '',

      url:
        button.dataset.productUrl || '',

      image:
        button.dataset.productImage || '',

      price:
        button.dataset.productPrice || '',

      comparePrice:
        button.dataset.productComparePrice || '',

      vendor:
        button.dataset.productVendor || '',

      variantId:
        button.dataset.variantId || '',

      available:
        button.dataset.productAvailable === 'true'

    };

  }


  function isCompared(id) {

    return getCompare().some(
      item =>
        String(item.id) === String(id)
    );

  }


  function syncCompareButtons() {

    const items =
      getCompare();

    document
      .querySelectorAll(
        '[data-vsx9-compare-toggle]'
      )
      .forEach(button => {

        const id =
          String(
            button.dataset.productId || ''
          );

        const active =
          items.some(
            item =>
              String(item.id) === id
          );

        button.classList.toggle(
          'is-active',
          active
        );

        button.setAttribute(
          'aria-pressed',
          active
            ? 'true'
            : 'false'
        );

        button.setAttribute(
          'aria-label',
          active
            ? `Remove ${button.dataset.productTitle || 'product'} from comparison`
            : `Compare ${button.dataset.productTitle || 'product'}`
        );

      });

  }


  function renderCompareBar() {

    const bar =
      document.querySelector(
        '[data-vsx9-compare-bar]'
      );

    if (!bar) {
      return;
    }

    const items =
      getCompare();

    const count =
      items.length;

    const countElement =
      bar.querySelector(
        '[data-vsx9-compare-count]'
      );

    const productsElement =
      bar.querySelector(
        '[data-vsx9-compare-products]'
      );

    if (countElement) {

      countElement.textContent =
        `${count} selected`;

    }


    if (productsElement) {

      productsElement.innerHTML = '';

      items.forEach(item => {

        const product =
          document.createElement('div');

        product.className =
          'vsx9-compare-mini';

        product.setAttribute(
          'data-vsx9-compare-mini',
          ''
        );

        product.innerHTML = `

          <div class="vsx9-compare-mini__image">

            ${
              item.image
                ? `<img
                    src="${escapeHTML(item.image)}"
                    alt="${escapeHTML(item.title)}"
                    loading="lazy"
                  >`
                : `<span aria-hidden="true">◎</span>`
            }

          </div>

          <span
            class="vsx9-compare-mini__title"
            title="${escapeHTML(item.title)}"
          >
            ${escapeHTML(item.title)}
          </span>

          <button
            type="button"
            class="vsx9-compare-mini__remove"
            data-vsx9-compare-remove="${escapeHTML(item.id)}"
            aria-label="Remove ${escapeHTML(item.title)}"
          >
            ×
          </button>

        `;

        productsElement.appendChild(
          product
        );

      });

    }


    if (count > 0) {

      bar.classList.add(
        'is-visible'
      );

      bar.setAttribute(
        'aria-hidden',
        'false'
      );

    } else {

      bar.classList.remove(
        'is-visible'
      );

      bar.setAttribute(
        'aria-hidden',
        'true'
      );

    }

  }


  function toggleCompare(button) {

    const id =
      String(
        button.dataset.productId || ''
      );

    if (!id) {
      return;
    }

    let items =
      getCompare();

    const existingIndex =
      items.findIndex(
        item =>
          String(item.id) === id
      );


    /* REMOVE */

    if (existingIndex >= 0) {

      items.splice(
        existingIndex,
        1
      );

      saveCompare(items);

      syncCompareButtons();
      renderCompareBar();

      showCompareToast(
        'Product removed from comparison'
      );

      return;
    }


    /* MAXIMUM LIMIT */

    if (
      items.length >=
      VSX9_MAX_COMPARE
    ) {

      showCompareToast(
        `You can compare up to ${VSX9_MAX_COMPARE} products`
      );

      const bar =
        document.querySelector(
          '[data-vsx9-compare-bar]'
        );

      if (bar) {

        bar.classList.add(
          'is-shake'
        );

        setTimeout(() => {
          bar.classList.remove(
            'is-shake'
          );
        }, 450);

      }

      return;
    }


    /* ADD */

    const newItem =
      buildCompareItem(button);

    items.push(
      newItem
    );

    saveCompare(items);

    syncCompareButtons();
    renderCompareBar();

    showCompareToast(
      `${newItem.title || 'Product'} added to comparison`
    );

  }


  function removeCompare(id) {

    const items =
      getCompare();

    const filtered =
      items.filter(
        item =>
          String(item.id) !==
          String(id)
      );

    saveCompare(filtered);

    syncCompareButtons();
    renderCompareBar();

  }


  function clearCompare() {

    const items =
      getCompare();

    if (!items.length) {
      return;
    }

    saveCompare([]);

    syncCompareButtons();
    renderCompareBar();

    showCompareToast(
      'Comparison cleared'
    );

  }


  /* =========================================================
     COMPARE TOAST
  ========================================================= */

  let compareToastTimer = null;

  function showCompareToast(message) {

    const toast =
      document.querySelector(
        '[data-vsx9-compare-toast]'
      );

    if (!toast) {
      return;
    }

    toast.textContent =
      message;

    toast.classList.add(
      'is-visible'
    );

    clearTimeout(
      compareToastTimer
    );

    compareToastTimer =
      setTimeout(() => {

        toast.classList.remove(
          'is-visible'
        );

      }, 2200);

  }


  /* =========================================================
     HTML ESCAPE
  ========================================================= */

  function escapeHTML(value) {

    return String(
      value || ''
    )
      .replace(
        /&/g,
        '&amp;'
      )
      .replace(
        /</g,
        '&lt;'
      )
      .replace(
        />/g,
        '&gt;'
      )
      .replace(
        /"/g,
        '&quot;'
      )
      .replace(
        /'/g,
        '&#039;'
      );

  }


  /* =========================================================
     CART
     EXISTING SYSTEM PRESERVED
  ========================================================= */

  async function getCart() {

    const response =
      await fetch(
        `${getRoot()}cart.js`,
        {
          method: 'GET',
          headers: {
            Accept:
              'application/json'
          },
          cache: 'no-store'
        }
      );

    if (!response.ok) {

      throw new Error(
        'Cart request failed'
      );

    }

    return response.json();

  }


  function updateCartCount(cart) {

    const count =
      Number(
        cart.item_count || 0
      );


    document
      .querySelectorAll(
        '[data-cart-count]'
      )
      .forEach(element => {

        element.textContent =
          count;

        element.setAttribute(
          'data-cart-count',
          count
        );

      });


    document
      .querySelectorAll(
        '.cart-count-bubble span'
      )
      .forEach(element => {

        element.textContent =
          count;

      });


    document
      .querySelectorAll(
        '.cart-count, .header__cart-count'
      )
      .forEach(element => {

        element.textContent =
          count;

      });


    document
      .querySelectorAll(
        'a[href="/cart"], a[href*="/cart"]'
      )
      .forEach(link => {

        link.setAttribute(
          'data-vsx9-cart-item-count',
          count
        );

      });

  }


  async function refreshCartUI() {

    try {

      const cart =
        await getCart();

      updateCartCount(
        cart
      );


      document.dispatchEvent(
        new CustomEvent(
          'cart:updated',
          {
            bubbles: true,
            detail: {
              cart
            }
          }
        )
      );


      document.dispatchEvent(
        new CustomEvent(
          'cart:refresh',
          {
            bubbles: true,
            detail: {
              cart
            }
          }
        )
      );


      document.dispatchEvent(
        new CustomEvent(
          'ajaxProduct:added',
          {
            bubbles: true,
            detail: {
              cart
            }
          }
        )
      );


      return cart;

    } catch (error) {

      console.warn(
        'VSX9 cart refresh failed:',
        error
      );

    }

  }


  function openCartDrawer() {

    const cartDrawer =
      document.querySelector(
        'cart-drawer'
      );

    if (
      cartDrawer &&
      typeof cartDrawer.open ===
        'function'
    ) {

      try {

        cartDrawer.open();

        return true;

      } catch (error) {}

    }


    const drawerTrigger =
      document.querySelector(
        '[data-cart-drawer-toggle]'
      );

    if (drawerTrigger) {

      drawerTrigger.click();

      return true;

    }


    return false;

  }


  async function addToCart(
    variantId,
    button
  ) {

    if (
      !variantId ||
      !button ||
      button.disabled
    ) {
      return;
    }


    const text =
      button.querySelector(
        '.vsx9-btn__text'
      );

    button.disabled =
      true;

    button.classList.add(
      'is-loading'
    );


    try {

      const response =
        await fetch(
          `${getRoot()}cart/add.js`,
          {
            method: 'POST',
            headers: {
              'Content-Type':
                'application/json',
              Accept:
                'application/json'
            },
            body: JSON.stringify({
              items: [
                {
                  id:
                    Number(
                      variantId
                    ),
                  quantity: 1
                }
              ]
            })
          }
        );


      let data = null;

      try {

        data =
          await response.json();

      } catch (error) {}


      if (!response.ok) {

        throw new Error(
          data?.description ||
          'Unable to add product'
        );

      }


      const cart =
        await refreshCartUI();


      button.classList.remove(
        'is-loading'
      );

      button.classList.add(
        'is-success'
      );


      if (text) {

        text.textContent =
          'Added ✓';

      }


      setTimeout(() => {

        openCartDrawer();

      }, 100);


      setTimeout(() => {

        button.disabled =
          false;

        button.classList.remove(
          'is-success'
        );

        if (text) {

          text.textContent =
            'Add to cart';

        }

      }, 1400);


      return cart;

    } catch (error) {

      console.error(
        'VSX9 Add to Cart Error:',
        error
      );


      button.disabled =
        false;

      button.classList.remove(
        'is-loading'
      );


      if (text) {

        text.textContent =
          'Try again';

      }


      setTimeout(() => {

        if (text) {

          text.textContent =
            'Add to cart';

        }

      }, 1600);

    }

  }


  /* =========================================================
     BUY NOW
  ========================================================= */

  async function buyNow(
    variantId,
    button
  ) {

    if (
      !variantId ||
      !button ||
      button.disabled
    ) {
      return;
    }


    const text =
      button.querySelector(
        '.vsx9-btn__text'
      );

    button.disabled =
      true;

    button.classList.add(
      'is-loading'
    );


    try {

      const response =
        await fetch(
          `${getRoot()}cart/add.js`,
          {
            method: 'POST',
            headers: {
              'Content-Type':
                'application/json',
              Accept:
                'application/json'
            },
            body: JSON.stringify({
              items: [
                {
                  id:
                    Number(
                      variantId
                    ),
                  quantity: 1
                }
              ]
            })
          }
        );


      if (!response.ok) {

        let errorData = null;

        try {

          errorData =
            await response.json();

        } catch (error) {}


        throw new Error(
          errorData?.description ||
          'Unable to add product'
        );

      }


      await response.json();


      window.location.href =
        `${getRoot()}checkout`;

    } catch (error) {

      console.error(
        'VSX9 Buy Now Error:',
        error
      );


      button.disabled =
        false;

      button.classList.remove(
        'is-loading'
      );


      if (text) {

        text.textContent =
          'Try again';


        setTimeout(() => {

          text.textContent =
            'Buy now';

        }, 1600);

      }

    }

  }


  /* =========================================================
     BIND
  ========================================================= */

  function bind() {

    /* -------------------------------------------------------
       WISHLIST
    ------------------------------------------------------- */

    document
      .querySelectorAll(
        '[data-vs-wishlist-toggle]'
      )
      .forEach(button => {

        if (
          button.dataset.vsx9Bound ===
          'true'
        ) {
          return;
        }

        button.dataset.vsx9Bound =
          'true';


        button.addEventListener(
          'click',
          event => {

            event.preventDefault();
            event.stopPropagation();

            toggleWishlist(
              button
            );

          }
        );

      });


    /* -------------------------------------------------------
       COMPARE
    ------------------------------------------------------- */

    document
      .querySelectorAll(
        '[data-vsx9-compare-toggle]'
      )
      .forEach(button => {

        if (
          button.dataset.vsx9CompareBound ===
          'true'
        ) {
          return;
        }

        button.dataset.vsx9CompareBound =
          'true';


        button.addEventListener(
          'click',
          event => {

            event.preventDefault();
            event.stopPropagation();

            toggleCompare(
              button
            );

          }
        );

      });


    /* -------------------------------------------------------
       ADD TO CART
    ------------------------------------------------------- */

    document
      .querySelectorAll(
        '[data-vsx9-add-to-cart]'
      )
      .forEach(button => {

        if (
          button.dataset.vsx9CartBound ===
          'true'
        ) {
          return;
        }

        button.dataset.vsx9CartBound =
          'true';


        button.addEventListener(
          'click',
          event => {

            event.preventDefault();
            event.stopPropagation();

            addToCart(
              button.dataset.variantId,
              button
            );

          }
        );

      });
    /* -------------------------------------------------------
       BUY NOW — COD KING COMPATIBILITY
       -------------------------------------------------------
       COD King owns the Buy Now click. We intentionally DO NOT
       preventDefault(), stopPropagation(), or perform our own
       cart/add request here because that would race the COD King
       popup and can create duplicate cart requests.

       Before COD King receives the click, we synchronously normalize
       the variant/quantity attributes it can read from the button.
    ------------------------------------------------------- */

    document
      .querySelectorAll(
        '[data-vsx9-buy-now], .codk-buy-now'
      )
      .forEach(button => {

        if (
          button.dataset.vsx9CodkCompatBound ===
          'true'
        ) {
          return;
        }

        button.dataset.vsx9CodkCompatBound =
          'true';

        function normalizeCodkBuyNow() {

          /*
             COD King can read the product form around the Buy Now button.
             Keep the hidden Shopify variant input synchronized as well as
             the COD King data attributes. This avoids a stale variant id
             when Shopify/section HTML is re-rendered.
          */
          const form = button.closest('form[data-product-form], form[data-type="add-to-cart-form"], form[action$="/cart/add"]');

          const rawVariant =
            String(
              button.getAttribute(
                'data-codk-variant-id'
              ) ||
              button.getAttribute(
                'data-variant-id'
              ) ||
              ''
            ).trim();

          const variantId =
            /^\d+$/.test(rawVariant)
              ? rawVariant
              : '';

          if (!variantId) {
            console.warn(
              'VSX9 CODK: Buy Now has no valid Shopify variant ID.',
              button
            );
            return false;
          }

          button.setAttribute('data-variant-id', variantId);
          button.setAttribute('data-codk-variant-id', variantId);
          button.setAttribute('data-form-variant-id', variantId);

          if (form) {
            const idInput = form.querySelector('input[name="id"][data-vsx9-codk-form-variant], input[name="id"]');
            if (idInput) {
              idInput.value = variantId;
            }

            const quantityInput = form.querySelector('input[name="quantity"]');
            if (quantityInput) {
              quantityInput.value = '1';
            }
          }
          button.setAttribute('data-quantity', '1');
          button.setAttribute('data-event-listener', 'true');
          button.setAttribute('codk-data-event-listener', 'true');
          button.classList.add('codk-buy-now');

          return true;
        }

        /* Run before the normal click phase without blocking it. */
        button.addEventListener(
          'pointerdown',
          normalizeCodkBuyNow,
          { capture: true, passive: true }
        );

        /* Keep attributes synchronized, but let COD King receive
           the original click normally. */
        button.addEventListener(
          'click',
          () => {
            normalizeCodkBuyNow();
          },
          true
        );

        /* Normalize immediately for COD King's initial DOM scan. */
        normalizeCodkBuyNow();

      });

    /* -------------------------------------------------------
       PRICE + AVAILABILITY FILTERS
   LIVE — NO PAGE RELOAD
------------------------------------------------------- */

function vsx9ApplyCollectionFilters() {

  const section =
    document.querySelector('[data-vsx9-section]');

  if (!section) return;

  const cards =
    Array.from(
      section.querySelectorAll('[data-vsx9-product-card]')
    );

  const minInput =
    section.querySelector('[data-vsx9-price-min]');

  const maxInput =
    section.querySelector('[data-vsx9-price-max]');

  const availability =
    section.querySelector('[data-vsx9-availability]');

  const empty =
    section.querySelector('[data-vsx9-live-filter-empty]');

  const minRaw =
    String(minInput?.value || '').trim();

  const maxRaw =
    String(maxInput?.value || '').trim();

  const stock =
    availability?.value || '';

  const min =
    minRaw === '' ? null : Number(minRaw);

  const max =
    maxRaw === '' ? null : Number(maxRaw);

  let visible = 0;

  cards.forEach(card => {

    const price =
      Number(
        card.dataset.vsx9FilterPrice || 0
      ) / 100;

    const available =
      String(
        card.dataset.vsx9FilterAvailable || '0'
      );

    let match = true;

    if (
      min !== null &&
      Number.isFinite(min)
    ) {
      match =
        match &&
        price >= min;
    }

    if (
      max !== null &&
      Number.isFinite(max)
    ) {
      match =
        match &&
        price <= max;
    }

    if (stock === '1') {
      match =
        match &&
        available === '1';
    }

    if (stock === '0') {
      match =
        match &&
        available === '0';
    }

    card.classList.toggle(
      'vsx9-filter-hidden',
      !match
    );

    if (match) {
      visible++;
    }

  });

  if (empty) {
    empty.hidden =
      visible !== 0;
  }

  const pagination =
    section.querySelector('.vsx9-pagination');

  const active =
    minRaw !== '' ||
    maxRaw !== '' ||
    stock !== '';

  if (pagination) {
    pagination.style.display =
      active ? 'none' : '';
  }

}


/* =====================================================
   LIVE FILTER BINDING
===================================================== */

function vsx9BindLiveFilters() {

  const section =
    document.querySelector('[data-vsx9-section]');

  if (!section) return;

  const filter =
    section.querySelector('[data-vsx9-live-filter]');

  if (
    !filter ||
    filter.dataset.vsx9LiveBound === 'true'
  ) {
    return;
  }

  filter.dataset.vsx9LiveBound =
    'true';

  const minInput =
    filter.querySelector('[data-vsx9-price-min]');

  const maxInput =
    filter.querySelector('[data-vsx9-price-max]');

  const availability =
    filter.querySelector('[data-vsx9-availability]');

  const clearButton =
    filter.querySelector('[data-vsx9-live-filter-clear]');

  let timer = null;

  const run =
    () => {

      clearTimeout(timer);

      timer =
        setTimeout(
          vsx9ApplyCollectionFilters,
          60
        );

    };

  minInput?.addEventListener(
    'input',
    run
  );

  maxInput?.addEventListener(
    'input',
    run
  );

  minInput?.addEventListener(
    'change',
    run
  );

  maxInput?.addEventListener(
    'change',
    run
  );

  availability?.addEventListener(
    'change',
    vsx9ApplyCollectionFilters
  );

  clearButton?.addEventListener(
    'click',
    () => {

      if (minInput) {
        minInput.value = '';
      }

      if (maxInput) {
        maxInput.value = '';
      }

      if (availability) {
        availability.value = '';
      }

      vsx9ApplyCollectionFilters();

    }
  );

  [minInput, maxInput].forEach(
    input => {

      input?.addEventListener(
        'keydown',
        event => {

          if (
            event.key !== 'Enter'
          ) {
            return;
          }

          event.preventDefault();

          vsx9ApplyCollectionFilters();

        }
      );

    }
  );

  vsx9ApplyCollectionFilters();

}


/* =====================================================
   LIVE FILTER BOOT
===================================================== */

vsx9BindLiveFilters();


/* -------------------------------------------------------
       SORT
    ------------------------------------------------------- */

    document
      .querySelectorAll(
        '[data-vsx9-sort]'
      )
      .forEach(select => {

        if (
          select.dataset.vsx9SortBound ===
          'true'
        ) {
          return;
        }

        select.dataset.vsx9SortBound =
          'true';


        select.addEventListener(
          'change',
          () => {

            const url =
              new URL(
                window.location.href
              );


            if (select.value) {

              url.searchParams.set(
                'sort_by',
                select.value
              );

            } else {

              url.searchParams.delete(
                'sort_by'
              );

            }


            window.location.href =
              url.toString();

          }
        );

      });


    /* -------------------------------------------------------
       COMPARE CLEAR
    ------------------------------------------------------- */

    document
      .querySelectorAll(
        '[data-vsx9-compare-clear]'
      )
      .forEach(button => {

        if (
          button.dataset.vsx9CompareClearBound ===
          'true'
        ) {
          return;
        }

        button.dataset.vsx9CompareClearBound =
          'true';


        button.addEventListener(
          'click',
          event => {

            event.preventDefault();

            clearCompare();

          }
        );

      });


    /* -------------------------------------------------------
       COMPARE REMOVE
    ------------------------------------------------------- */

    document.addEventListener(
      'click',
      event => {

        const removeButton =
          event.target.closest(
            '[data-vsx9-compare-remove]'
          );

        if (!removeButton) {
          return;
        }

        event.preventDefault();

        const id =
          removeButton.dataset
            .vsx9CompareRemove;

        removeCompare(id);

      }
    );

  }



  /* =========================================================
     MOBILE FILTER / SORT SHEET
     UI ONLY — existing filter/sort logic is preserved.
  ========================================================= */

  function vsx9BindMobileFilterSheets() {

    document
      .querySelectorAll('[data-vsx9-mobile-sheet]')
      .forEach(sheet => {

        if (
          sheet.dataset.vsx9MobileSheetBound === 'true'
        ) {
          return;
        }

        sheet.dataset.vsx9MobileSheetBound = 'true';

        const toolbar =
          sheet.closest('.vsx9-toolbar');

        if (!toolbar) {
          return;
        }

        const openButtons =
          toolbar.querySelectorAll(
            '[data-vsx9-mobile-open]'
          );

        const overlay =
          toolbar.querySelector(
            '[data-vsx9-mobile-overlay]'
          );

        const closeButtons =
          sheet.querySelectorAll(
            '[data-vsx9-mobile-close]'
          );

        const title =
          sheet.querySelector(
            '[data-vsx9-mobile-sheet-title]'
          );

        const filterControls =
          toolbar.querySelector(
            '.vsx9-toolbar__filters'
          );

        const sortControl =
          toolbar.querySelector(
            '.vsx9-sort'
          );

        function closeSheet() {

          sheet.classList.remove('is-open');

          sheet.setAttribute(
            'aria-hidden',
            'true'
          );

          sheet.removeAttribute(
            'data-sheet-mode'
          );

          if (filterControls) {
            filterControls.style.display = '';
          }

          if (sortControl) {
            sortControl.style.display = '';
          }

          if (overlay) {
            overlay.classList.remove('is-open');
            overlay.setAttribute(
              'aria-hidden',
              'true'
            );
          }

          openButtons.forEach(button => {
            button.setAttribute(
              'aria-expanded',
              'false'
            );
          });

          document.documentElement.classList.remove(
            'vsx9-mobile-sheet-open'
          );

        }

        function openSheet(mode) {

          if (mode === 'filter') {

            if (filterControls) {
              filterControls.style.display = 'grid';
            }

            if (sortControl) {
              sortControl.style.display = 'none';
            }

            if (title) {
              title.textContent = 'Filters';
            }

          }

          if (mode === 'sort') {

            if (filterControls) {
              filterControls.style.display = 'none';
            }

            if (sortControl) {
              sortControl.style.display = 'flex';
            }

            if (title) {
              title.textContent = 'Sort By';
            }

          }

          sheet.setAttribute(
            'data-sheet-mode',
            mode
          );

          sheet.classList.add('is-open');

          sheet.setAttribute(
            'aria-hidden',
            'false'
          );

          if (overlay) {
            overlay.classList.add('is-open');
            overlay.setAttribute(
              'aria-hidden',
              'false'
            );
          }

          openButtons.forEach(button => {
            button.setAttribute(
              'aria-expanded',
              button.dataset.vsx9MobileOpen === mode
                ? 'true'
                : 'false'
            );
          });

          document.documentElement.classList.add(
            'vsx9-mobile-sheet-open'
          );

        }

        openButtons.forEach(button => {

          button.addEventListener(
            'click',
            event => {

              event.preventDefault();
              event.stopPropagation();

              const mode =
                button.dataset.vsx9MobileOpen;

              if (
                sheet.classList.contains('is-open') &&
                sheet.dataset.sheetMode === mode
              ) {
                closeSheet();
                return;
              }

              openSheet(mode);

            }
          );

        });

        closeButtons.forEach(button => {

          button.addEventListener(
            'click',
            event => {

              event.preventDefault();
              event.stopPropagation();

              closeSheet();

            }
          );

        });

        overlay?.addEventListener(
          'click',
          event => {

            event.preventDefault();
            event.stopPropagation();

            closeSheet();

          }
        );

        document.addEventListener(
          'keydown',
          event => {

            if (
              event.key === 'Escape' &&
              sheet.classList.contains('is-open')
            ) {
              closeSheet();
            }

          }
        );

        window.addEventListener(
          'resize',
          () => {

            if (
              window.innerWidth > 749 &&
              sheet.classList.contains('is-open')
            ) {
              closeSheet();
            }

          }
        );

      });

  }


  /* =========================================================
     INIT
  ========================================================= */

  async function init() {

    bind();

    vsx9BindMobileFilterSheets();

    syncWishlist();

    syncCompareButtons();

    renderCompareBar();


    try {

      const cart =
        await getCart();

      updateCartCount(
        cart
      );

    } catch (error) {}

  }


  /* =========================================================
     WISHLIST EVENTS
  ========================================================= */

  document.addEventListener(
    'vs:wishlist:updated',
    syncWishlist
  );


  /* =========================================================
     COMPARE EVENTS
  ========================================================= */

  document.addEventListener(
    VSX9_COMPARE_EVENT,
    event => {

      syncCompareButtons();
      renderCompareBar();

    }
  );


  /* =========================================================
     CROSS TAB WISHLIST + COMPARE
  ========================================================= */

  window.addEventListener(
    'storage',
    event => {

      if (
        event.key ===
        VSX9_WISHLIST_KEY
      ) {

        syncWishlist();

      }


      if (
        event.key ===
        VSX9_COMPARE_KEY
      ) {

        syncCompareButtons();
        renderCompareBar();

      }

    }
  );


  /* =========================================================
     COD KING — DYNAMIC BUTTON SAFETY NET
     ---------------------------------------------------------
     Shopify/theme apps can replace collection HTML after load.
     Keep CODK attributes synchronized without taking over the
     Buy Now click.
  ========================================================= */

  function vsx9NormalizeAllCodkButtons() {

    document
      .querySelectorAll(
        '[data-vsx9-buy-now], .codk-buy-now'
      )
      .forEach(button => {

        const rawVariant =
          String(
            button.getAttribute('data-codk-variant-id') ||
            button.getAttribute('data-variant-id') ||
            ''
          ).trim();

        if (!/^\d+$/.test(rawVariant)) {
          return;
        }

        button.setAttribute('data-variant-id', rawVariant);
        button.setAttribute('data-codk-variant-id', rawVariant);
        button.setAttribute('data-form-variant-id', rawVariant);
        button.setAttribute('data-quantity', '1');

        const form = button.closest('form[data-product-form], form[data-type="add-to-cart-form"], form[action$="/cart/add"]');
        if (form) {
          const idInput = form.querySelector('input[name="id"][data-vsx9-codk-form-variant], input[name="id"]');
          if (idInput) idInput.value = rawVariant;
          const quantityInput = form.querySelector('input[name="quantity"]');
          if (quantityInput) quantityInput.value = '1';
        }
        button.setAttribute('data-event-listener', 'true');
        button.setAttribute('codk-data-event-listener', 'true');
        button.classList.add('codk-buy-now');

      });

  }

  setTimeout(vsx9NormalizeAllCodkButtons, 0);
  setTimeout(vsx9NormalizeAllCodkButtons, 500);

  document.addEventListener(
    'shopify:section:load',
    () => {
      setTimeout(vsx9NormalizeAllCodkButtons, 0);
    }
  );


  /* =========================================================
     SHOPIFY SECTION LOAD
  ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    () => {

      bind();

      syncWishlist();

      syncCompareButtons();

      renderCompareBar();

    }
  );


  /* =========================================================
     DOM READY
  ========================================================= */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }

})();
/* vsx9-live-filter-section-rebind */
document.addEventListener(
  'shopify:section:load',
  () => {
    if (
      typeof vsx9BindLiveFilters ===
      'function'
    ) {
      vsx9BindLiveFilters();
    }
  }
);
